<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Hg6ZOd/tc-custom/9781488083488.jpg?1726519109873" alt="This image is the cover for the book Crowned for the Sheikh's Baby, One Night With Consequences"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Crowned for the Sheikh's Baby, One Night With Consequences
      </h1>
      <p class="bookDescription body article font2">
        <b>A seductive sheikh faces the consequences of one hot night with a hotel maid in this contemporary romance by a <i>USA Today</i>–bestselling author.</b><br/><br/>The last thing sensible maid Hannah Wilson expects is to be whisked off to a glamorous party by Sheikh Kulal Al Diya. Their intense chemistry and searing kiss lead to the most amazing night of her life—with the most shocking consequences! Now Kulal will do anything to claim his heir. Even if it means making Hannah his desert queen!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sharon Kendrick
      </h2>
      
      <p class="authorDescription body article">Sharon Kendrick started story-telling at the age of eleven and has never stopped. She likes to write fast-paced, feel-good romances with heroes who are so sexy they&rsquo;ll make your toes curl! She&#160;lives in the beautiful city of Winchester &ndash; where she can see the cathedral from her window (when standing on tip-toe!). She has two children, Celia and Patrick and her passions include music, books, cooking and eating &ndash; and drifting into daydreams while working out new plots.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ac7aca36